import { LayoutRefArray } from '@wix/thunderbolt-catharsis'
import { addCssValueToLayoutSizes } from '@wix/thunderbolt-becky-root'
import { LayoutDataItems, SingleLayoutData, VariantRelationViewItem } from '@wix/thunderbolt-becky-types'

export const getSingleLayoutForVariant = (
	compLayout: LayoutRefArray | undefined,
	variantId: 'default' | 'Mobile' | string
): SingleLayoutData | undefined => {
	if (variantId !== 'default') {
		const layout = compLayout?.values.find(
			(l) => l.type === 'VariantRelation' && l.variants.find((v) => v.type === variantId)
		)! as VariantRelationViewItem<LayoutDataItems>
		return addCssValueToLayoutSizes(layout?.to as SingleLayoutData)
	}

	const compSingleLayout = compLayout?.values.find((layout) => layout.type === 'SingleLayoutData') as SingleLayoutData
	return addCssValueToLayoutSizes(compSingleLayout)
}
